<!-- Cancel Subscription  -->
<p-dialog [(visible)]="visible" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '540px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <form [formGroup]="CancelSubscriptionForm" (ngSubmit)="CancelSubscription()">
      <!-- Header -->
      <div class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300">

        <h2 class="mb-0 text-base font-bold">{{'SUBSCRIPTION_CANCEL.CANCEL_SUBS' | translate }}</h2>
        <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)"></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100">

        <div class="-my-3">
          <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="subscription-cancel-info-message">
            {{'SUBSCRIPTION_CANCEL.INFO' |translate }}
          </p-message>
        </div>

        <div class="p-4">

          <div class="mb-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SUBSCRIPTION_CANCEL.CHOOSE_TYPE'
              |translate }}
              <sup class="p-error">*</sup>
            </label>

            <ul class="flex align-items-center justify-content-between list-none p-0 m-0 text-sm">
              <li class="mr-3">
                <p-radioButton (onClick)="GetCancelType('ImmediateCancel')" name="cancel_type" value="ImmediateCancel"
                  inputId="option1"
                  formControlName="cancel_type">
                </p-radioButton>
                <label for="option1" class="ml-2">{{'SUBSCRIPTION_CANCEL.IMMEDIIETLY' | translate}}</label>
              </li>
              <li class="mr-3">
                <p-radioButton *ngIf="ShowEndOfBillingButton" (onClick)="GetCancelType('EndOfBillingPeriod')"
                  name="cancel_type" value="EndOfBillingPeriod"
                  inputId="option2"
                  formControlName="cancel_type">
                </p-radioButton>
                <label for="option2" class="ml-2">{{'SUBSCRIPTION_CANCEL.END_OF_BILLING' | translate}}</label>
              </li>

              <li>
                <p-radioButton *ngIf="ShowEndOfContractButton" (onClick)="GetCancelType('EndOfContract')"
                  name="cancel_type" value="EndOfContract" 
                  inputId="option3" formControlName="cancel_type">
                </p-radioButton>
                <label for="option3" class="ml-2">{{'SUBSCRIPTION_CANCEL.END_OF_CONTRACT' | translate}}</label>
              </li>
            </ul>

          </div>

          <!-- Show Subscription 1 -->
          <div>
            <div class="mb-4">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SUBSCRIPTION_CANCEL.CANCEL_DATE' | translate }}</label>
              <strong class="block">{{ cancellationDate | date : 'd MMM yy'}} ({{'SUBSCRIPTION_CANCEL.'+ text | translate}})</strong>
            </div>

            <div class="">
              <label
                class="font-medium text-700 text-xs mb-2 block uppercase">{{'SUBSCRIPTION_CANCEL.CANCEL_REASON' | translate}}</label>
              <textarea pInputTextarea class="w-full h-4rem text-sm" formControlName="reason"
                [placeholder]="'SUBSCRIPTION_CANCEL.REASON' | translate">
          </textarea>
            </div>
          </div>
          <!-- Show Subscription 1 -->

        </div>

      </div>
      <!-- Content -->

      <!-- Footer -->
      <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300">
        <button pButton pRipple type="button" [label]="'SUBSCRIPTION_CANCEL.CANCEL' | translate"
          class="p-button-text text-sm" (click)="closePopup(false)"></button>
        <button pButton pRipple type="submit" [loading]="isFormSubmitting"
          [label]="'SUBSCRIPTION_CANCEL.BTN_CANCEL' | translate" class="text-sm"></button>

      </div>
      <!-- Footer -->
    </form>

  </ng-template>

</p-dialog>
<!-- Cancel Subscription  -->

